// ConfirmDialog.jsx
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography
} from "@mui/material";

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  message = "Êtes-vous sûr ?",
  pendingMessage = null,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirmation</DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {message}
        </DialogContentText>

        {pendingMessage && (
          <Typography
            variant="body1"
            sx={{
              p: 1.5,
              borderRadius: 1,
              bgcolor: "grey.100",
              border: "1px solid #ddd",
              fontStyle: "italic"
            }}
          >
            « {pendingMessage} »
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Annuler
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={onConfirm}
        >
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
}
